import { FC, useEffect, useState } from "react";
import styles from "./Footer.module.scss";
import { useAppSelector } from "../../../services/hooks";
import { dataFooter, routerFooter } from "./constants";
import logo from "../../../images/logo.svg";
import mail from "../../../images/footer/mail.svg";
import twitter from "../../../images/footer/twitter.svg";
import heart from "../../../images/footer/heart.svg";
import { useLocation } from "react-router-dom";

export const Footer: FC = () => {
  const lang = useAppSelector((state) => state.lang.lang);
  const [content, setContent] = useState(dataFooter[lang]);
  const router = useLocation();
  useEffect(() => {
    setContent(dataFooter[lang]);
  }, [lang]);
  return (
    <footer
      className={`${styles.footer} ${
        (router.pathname === "/login" || router.pathname === "/register") &&
        styles.footer_block
      }`}
    >
      <div className={styles.info}>
        <img className={styles.logo} src={logo} alt="Логотип" />
        <p className={styles.text}>
          Erleben Sie unvergleichliche Begleitung und diskrete, unvergessliche
          Momente mit unserer handverlesenen Auswahl an eleganten Escorts,
          maßgeschneidert, um Ihre Wünsche zu erfüllen und Ihre Privatsphäre zu
          gewährleisten.
        </p>
        <p className={styles.text}>
          Stöbern Sie in unserer sexy Galerie, um die perfekte Begleitung für
          jeden Anlass zu finden, bei der Stil, Klasse und Respekt im
          Mittelpunkt jedes Treffens stehen.
        </p>
      </div>
      <div className={styles.block}>
        <div className={styles.block_link}>
          <ul className={styles.nav}>
            <h3 className={styles.nav_title}>Pages</h3>
            {routerFooter.map((item, index) => (
              <li className={styles.nav_item} key={index}>
                <a href={item.path} className={styles.nav_link}>
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
          <p className={styles.copirate}>
            © www.termingirl.com <img src={heart} alt="Icon" /> All Rights
            Reserved
          </p>
        </div>
        <div className={styles.mail}>
          <h4 className={styles.mail_title}>Bleib verbunden</h4>
          <div className={styles.mail_link}>
            <img src={mail} alt="Icon" className={styles.mail_icon} />
            info@termingirl.com
          </div>
          <div className={styles.mail_link}>
            <img src={twitter} alt="Icon" className={styles.mail_icon} />
          </div>
        </div>
      </div>
      <p className={styles.copirate_item}>
        © www.termingirl.com <img src={heart} alt="Icon" /> All Rights Reserved
      </p>
    </footer>
  );
};
